module.exports = __webpack_public_path__ + "static/media/zhuzijianshan_web.d9cf02be.webp";